import { render, staticRenderFns } from "./WebsiteMobileNavigationDropdown.vue?vue&type=template&id=02195771"
import script from "./WebsiteMobileNavigationDropdown.vue?vue&type=script&lang=ts"
export * from "./WebsiteMobileNavigationDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports